<form [formGroup]="form">
  <section class="start-date">
    <mat-checkbox
      (change)="setStartDateFixed($event.checked)"
      [checked]="startDateFixed"
      >Fixed Start Date
    </mat-checkbox>
    @if (startDateFixed) {
      <mat-form-field>
        <input
          (click)="startDate.open()"
          (dateChange)="onStartDateChange()"
          (inputChange)="onStartDateChange()"
          [matDatepicker]="startDate"
          formControlName="startDate"
          matInput
          placeholder="Start Date"
          />
        <mat-datepicker-toggle
          [for]="startDate"
          matSuffix
        ></mat-datepicker-toggle>
        <mat-datepicker
          #startDate
          [startAt]="form.controls['startDate'].value"
        ></mat-datepicker>
      </mat-form-field>
    }
  </section>
  <section class="end-date">
    <mat-checkbox
      (change)="setEndDateFixed($event.checked)"
      [checked]="endDateFixed"
      >Fixed End Date</mat-checkbox
      >
      @if (endDateFixed) {
        <mat-form-field>
          <input
            (click)="endDate.open()"
            (dateChange)="onEndDateChange()"
            (inputChange)="onEndDateChange()"
            [matDatepicker]="endDate"
            [min]="form.controls['startDate'].value || null"
            formControlName="endDate"
            matInput
            placeholder="End Date"
            />
          <mat-datepicker-toggle [for]="endDate" matSuffix></mat-datepicker-toggle>
          <mat-datepicker
            #endDate
            [startAt]="form.controls['endDate'].value"
          ></mat-datepicker>
        </mat-form-field>
      }
    </section>
  </form>
